import React, {Component} from 'react';
import {func, string, number, arrayOf, shape} from 'prop-types';
import {default as Dialog} from '@sinclair-digital/sbg-storyline-components/src/components/Dialog';
import styles from './MismatchesModal.scss';

class MismatchesModal extends Component {
    static propTypes = {
        onClose: func.isRequired,
        mismatches: arrayOf(
            shape({
                uuid: string.isRequired,
                teaserList: string.isRequired,
                title: string.isRequired,
                position: number.isRequired,
                intendedPosition: number.isRequired,
            }),
        ).isRequired,
    };

    render() {
        return (
            <Dialog isOpen={true} onClose={this.props.onClose}>
                <h3 className={styles.header}>
                    Your teaser placement has changed.
                    <button className={styles.close} onClick={this.props.onClose} />
                </h3>
                <div className={styles.body}>
                    <p>
                        Teaser placement for the manual teaser(s) you have created has changed. Below is the list of
                        affected manual teaser(s).
                    </p>
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Teaser List</th>
                                <th>Current Position</th>
                                <th>Intended Position</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.mismatches.map(m => (
                                <tr key={m.uuid}>
                                    <td>{m.title}</td>
                                    <td>{m.teaserList}</td>
                                    <td>{m.position}</td>
                                    <td>{m.intendedPosition}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <p>Please adjust if needed.</p>
                </div>
            </Dialog>
        );
    }
}

export default MismatchesModal;
